import { Component, inject, Signal, signal } from '@angular/core';
import { ApiHealthService } from '../../../services/api.health.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-version-display',
  imports: [],
  templateUrl: './version-display.component.html',
  styleUrl: './version-display.component.scss',
})
export class VersionDisplay {
  private _apiHealthService: ApiHealthService = inject(ApiHealthService);

  public APP_Version: Signal<string | undefined> = signal(
    environment.api.appVersion,
  );
  public API_Version: Signal<string | undefined> =
    this._apiHealthService.apiVersion;
}
